import React from "react";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Button from "components/CustomButtons/Button.js";
import PublishIcon from "@mui/icons-material/Publish";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles(styles);
export default function FileUpload(props) {
  const { handleFileChange, row} = props;
  const classes = useStyles();

  let fileInput = React.createRef();
  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      handleFileChange(row, file);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleClick = () => {
    fileInput.current.click();
  };
  return (
    <div className="fileinput" style={{ marginTop: "0px",    marginBottom: "0px" }}>
      <input type="file" onChange={handleImageChange} ref={fileInput} />
      <div>
        {!props.disabled ?
          <Tooltip title="Ajouter un fichier">
            <Button
              onClick={() => handleClick()}
              color={"warning"}
              className={classes.actionButton}
            >
              <PublishIcon fontSize="large" />
            </Button>
          </Tooltip>
          : <></>}
      </div>
    </div>
  );
}
